import React from 'react';

const CaracteristicasDeckTablonWpc = () => {
  return (
    <section className="bg-light">
      <div className="container">
        <div className="section-heading text-center mb-5">
          <h2 className="h1 font-weight-800">Ficha Técnica</h2>
          <p className="w-md-75 w-lg-60 mx-auto">
            Especificaciones precisas para una instalación profesional y duradera.
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="bg-white p-4 p-lg-5 rounded shadow-sm">
              <div className="row">
                <div className="col-md-6 mb-4 mb-md-0">
                  <h3 className="h4 mb-3 text-primary">Medidas</h3>
                  <ul className="list-unstyled">
                    <li className="py-3 border-bottom"><strong className="me-2 text-dark">Largo:</strong> 2.90 m</li>
                    <li className="py-3 border-bottom"><strong className="me-2 text-dark">Ancho:</strong> 14 cm</li>
                    <li className="py-3 border-bottom"><strong className="me-2 text-dark">Espesor:</strong> 1.5 cm</li>
                    <li className="py-3"><strong className="me-2 text-dark">Área por pieza:</strong> 0.406 m²</li>
                  </ul>
                </div>
                <div className="col-md-6 ps-md-5 border-start-md">
                  <h3 className="h4 mb-3 text-primary">Propiedades</h3>
                  <ul className="list-unstyled">
                    <li className="py-3 border-bottom"><strong className="me-2 text-dark">Peso por pieza:</strong> 7.7 Kg</li>
                    <li className="py-3 border-bottom"><strong className="me-2 text-dark">Uso:</strong> Exterior (Terrazas, Jardines, Albercas)</li>
                    <li className="py-3 border-bottom"><strong className="me-2 text-dark">Protección:</strong> Filtro UV de alta resistencia</li>
                    <li className="py-3"><strong className="me-2 text-dark">Material:</strong> WPC Coextruido</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaracteristicasDeckTablonWpc;